module.exports = __webpack_public_path__ + "static/media/home_avatar3.79739966.png";